import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './ProductManage.scss';
import { getAllProducts, createNewProductService, deleteProductService, editProductService } from '../../../services/productService';
import { getAllCountries } from '../../../services/countryService';
import { getAllCategories } from '../../../services/categoryService';
import ModalProduct from './ModalProduct';
import ModalEditProduct from './ModalEditProduct';
import { Scrollbars } from 'react-custom-scrollbars';
// import ScrollArea from 'react-scrollbar';
import { emitter } from '../../../utils/emitter' // ham tao su kien
class ProductManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrProducts: [],
            arrCountries: [],
            isOpenModal: false,
            isOpenModalEditProduct: false,
            ProductEdit: [],
        }
    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllProductFromReact()

    }
    getAllProductFromReact = async () => {
        let response = await getAllProducts("All");
        let responseCountry = await getAllCountries("All");
        let responseCategory = await getAllCategories("All");
        if (response && response.errCode == 0) {
            this.setState({
                arrProducts: response.products,
                arrCountries: responseCountry.countries,
                arrCategories: responseCategory.categories
            })
            console.log(this.state.arrProducts);
        }
    }
    createNewProduct = async (data) => {

        try {
            let response = await createNewProductService(data);
            if (response && response.errCode !== 0) {
                await this.getAllProductFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("Product didn't create");
            }

        } catch (error) {

        }
    }
    editProduct = async (data) => {
        try {
            let response = await editProductService(data);
            if (response && response.errCode !== 0) {
                await this.getAllProductFromReact()
                this.setState({
                    isOpenModalEditProduct: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("Product didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewProduct = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewProduct");
    }
    handleDeleteProduct = async (data) => {

        let response = await deleteProductService(data);
        if (response && response.errCode !== 0) {
            await this.getAllProductFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("Product didn't create");
        }

    }
    handleEditProduct = async (data) => {

        this.setState({
            isOpenModalEditProduct: true,
            ProductEdit: data
        })
    }
    toogleProductModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleProductEditModal = () => {
        this.setState({
            isOpenModalEditProduct: !this.state.isOpenModalEditProduct
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        let arrProducts = this.state.arrProducts;
        // console.log('check render : ', arrProducts);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="products-container">
                <ModalProduct
                    isOpen={this.state.isOpenModal}
                    countries={this.state.arrCountries}
                    categories={this.state.arrCategories}
                    tooglefromParent={this.toogleProductModal}
                    createNewProduct={this.createNewProduct}
                />
                {this.state.isOpenModalEditProduct &&
                    <ModalEditProduct
                        isOpen={this.state.isOpenModalEditProduct}
                        tooglefromParent={this.toogleProductEditModal}
                        currentProduct={this.state.ProductEdit}
                        editCurrentProduct={this.editProduct}
                    // createNewProduct={this.createNewProduct}
                    />
                }

                <div className='title text-center'> Manage Product by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewProduct()}
                    ><i class="fas fa-plus"></i>Add new product</button>

                </div>
                <Scrollbars
                    autoHeight
                    autoHeightMax={200}
                >
                    <div className='product-table mt-3 mx-1'>
                        <table id="customers">
                            <tr>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Country</th>
                                <th>Category</th>
                                <th>Action</th>
                            </tr>

                            {/* su dung vong lap MAP function javascript */}
                            {arrProducts && arrProducts.map((item, index) => {
                                // console.log('check map', item, index);
                                return (
                                    <tr>
                                        <td><img src={item.thumbnail} width="60" height="60" /></td>
                                        <td>{item.name}</td>
                                        <td>{item.country}</td>
                                        <td>{item.category}</td>
                                        <td>
                                            <button className='btn-edit'
                                                onClick={() => this.handleEditProduct(item)}
                                            ><i class="fas fa-pencil-alt"></i></button>
                                            <button className='btn-delete'
                                                onClick={() => this.handleDeleteProduct(item)}
                                            > <i className="fas fa-trash-alt"></i></button>

                                        </td>
                                    </tr>

                                )
                            })
                            }



                        </table>
                    </div>
                </Scrollbars>





            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductManage);
